module.exports = __webpack_public_path__ + "static/media/sonic.7acbc7b.mid";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sonic.mid
// module id = +dpC
// module chunks = 0